module.exports = __webpack_public_path__ + "static/img/usage-electr.7cd6770a.png";